import React, { Component } from "react";
import ComponentSaq from "../../components/ComponentSaq";
import { formDataSaqAep } from "../../data/4.0/formDataSaqAep";
import { formDataSaqB } from "../../data/4.0/formDataSaqB";
import { formDataSaqC } from "../../data/4.0/formDataSaqC";
import { formDataSaqDMe } from "../../data/4.0/formDataSaqDMe";
import { formDataSaqBip } from "../../data/4.0/formDataSaqBip";
import { formDataSaqDsp } from "../../data/4.0/formDataSaqDsp";
import { formDataSaqA } from "../../data/4.0/formDataSaqA";

class EditSaq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: null,
      saqId: null,
    };
  }

  componentDidMount = () => {
    const urlPath = this.props.location.pathname.split("/");
    const type = urlPath[2];
    const saqId = urlPath[3];

    this.setState({
      type: type,
      saqId: saqId,
    });
  };

  render() {
    const { type, saqId } = this.state;

    if (type && saqId) {
      return (
        <ComponentSaq
          saqId={saqId}
          type={type}
          formDataSaq={
            type === "A"
              ? formDataSaqA
              : type === "B"
              ? formDataSaqB
              : type === "C"
              ? formDataSaqC
              : type === "D-ME"
              ? formDataSaqDMe
              : type === "A-EP"
              ? formDataSaqAep
              : type === "B-IP"
              ? formDataSaqBip
              : type === "D-SP"
              ? formDataSaqDsp
              : formDataSaqA
          }
        />
      );
    } else {
      return "";
    }
  }
}

export default EditSaq;
